import templates from 'src/templates/page';
import DOM_SELECTOR_CONFIG from 'src/config/domSelectorConfig';
import registrationStore from 'src/stores/registrationStore';
import appConfig from 'src/utils/appConfig';
import { interactionListener } from 'src/utils/views/interactionHandler';
import clickTracker from 'src/utils/events/clickEvent/clickTracker';
import View from 'src/components/shared/view';
import getLanguageSelectionList from 'src/config/getLanguageSelectionList';
import { addAuthTokenToURL } from 'src/libs/autoLoginService';
import { getReturnToURLFromParams } from 'src/router/queryString';
import { dashboardURL } from '@lessonnine/babbel-urls.js';
import translate from 'src/templates/helpers/translate';

const {
  PAGE_VIEW,
  CONTINUE_BUTTON,
  ANSWER_BUTTON
} = DOM_SELECTOR_CONFIG.PAGE_DATA_SELECTORS;

const selectorTemplateVariables = {
  dataView: PAGE_VIEW,
  continueButton: CONTINUE_BUTTON,
  answerButton: ANSWER_BUTTON
};

const LOCALE_KEY = 'locales.';

class PageView extends View {
  render(node, flowLocales) {
    const template = this.optionHandlers.template(templates, node);

    const { locale } = appConfig.serialize();

    const languageSelectionList = getLanguageSelectionList(locale);

    const flowLocalesFiltered = flowLocales.filter((flowLocale) => {
      return flowLocale !== locale;
    });


    const templateVariables = Object.assign({
      languageSelectionList,
      currentLocale: this.createCurrentLocaleObject(locale),
      localesList: this.createLocalesList(flowLocalesFiltered, locale),
      userEmail: registrationStore.getUserData().email,
      learningLanguage: appConfig.getLanguageTranslation()
    }, selectorTemplateVariables, node.variables, node.options);

    this.destroy();
    this.appendToBody(template(templateVariables));

    this.container = this.domSelector.getPageContainer();
    this.continueButton = this.domSelector.getPageContinueButton();
    this.answerButtons = this.domSelector.getPageAnswerButtons();
    this.navbarLogo = this.domSelector.getNavbarLogo();

    this.initEvents();
    this.setNavbarLogoUrl();
  }

  setNavbarLogoUrl() {
    const signInToken = registrationStore.getUserData().signin_token;

    // Only set URL when logo and sign-in token are available, otherwise will use default value
    // The reason of the check, when PageNode exists before registration, the logo href won't be undefined
    if (this.navbarLogo && signInToken) {
      const { accountsLoginUrl } = appConfig.getMyConfig();
      const returnToURL = getReturnToURLFromParams() || dashboardURL();

      const loginUrlWithReturnTo = `${accountsLoginUrl}?return_to=${encodeURIComponent(returnToURL)}`;
      this.navbarLogo.href = addAuthTokenToURL(loginUrlWithReturnTo, signInToken);
    }

    // no default return value since we won't change the navbar logo URL
  }

  translateLocale(locale) {
    return translate(LOCALE_KEY.concat(locale));
  }

  initEvents() {
    interactionListener(this.continueButton, 'click', this.onContinueButtonInteracted.bind(this));
    interactionListener(this.answerButtons, 'click', this.onAnswerButtonInteracted.bind(this));

    [
      this.domSelector.getSigninLink(),
      this.domSelector.getSkipRegisterButton(),
      ...this.domSelector.getCardButtons(),
      ...this.domSelector.getLanguageSelectionLinks()
    ].forEach((el) => clickTracker.initialize(el));
  }

  createLocalesList(flowLocales, currentLocale) {
    return flowLocales.map((locale) => {
      return {
        locale: locale,
        translation: this.translateLocale(locale),
        url: window.location.href.replace(currentLocale, locale)
      };
    });
  }

  createCurrentLocaleObject(locale) {
    return {
      locale: locale,
      localeTranslation: this.translateLocale(locale)
    };
  }

  onContinueButtonInteracted() {
    this.destroy();
    this.emitCompleted();
  }

  onAnswerButtonInteracted(event) {
    this.answerButtons.forEach((answerButton) => {
      answerButton.disabled = true;
    });

    const selectedValue = event.target.value;
    const selectedButtonName = event.target.dataset.name;
    const payload = {};

    if (selectedButtonName) {
      payload[selectedButtonName] = selectedValue;
    }

    this.emitCompleted(payload);
  }

  destroy() {
    if (this.container) {
      if (this.continueButton) {
        interactionListener(this.continueButton, 'click', this.onContinueButtonInteracted, 'remove');
      }

      if (this.answerButtons) {
        interactionListener(this.answerButtons, 'click', this.onAnswerButtonInteracted, 'remove');
      }

      this.resetElements();
      this.container = null;
    }
    super.destroy();
  }

  resetElements() {
    this.container = null;
    this.continueButton = null;
    this.answerButtons = null;
  }
}

export default PageView;
